import { render, staticRenderFns } from "./MDashboardWidgetSingle.vue?vue&type=template&id=75cb3d04&scoped=true"
import script from "./MDashboardWidgetSingle.vue?vue&type=script&lang=ts"
export * from "./MDashboardWidgetSingle.vue?vue&type=script&lang=ts"
import style0 from "./MDashboardWidgetSingle.vue?vue&type=style&index=0&id=75cb3d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.37_css-loader@6.11.0_webpack@5.93.0__ejs@3.1.10_hoga_mqdlk73zogqfmm4uknw3a3yvy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cb3d04",
  null
  
)

export default component.exports